<ui-grid [data]="robotAssets?.source$ | async"
         [selectable]="false"
         [refreshable]="false"
         [expandedEntry]="editedRobot"
         [noDataMessage]="(!default ? 'assets_modal_grid_no_results' : 'assets_modal_grid_optional') | translate">
    <ui-grid-header>
        <ui-header-button type="main">
            <ng-template>
                <button [disabled]="editedRobot"
                        [matTooltip]="'assets_modal_action_add' | translate"
                        (click)="addEntry()"
                        mat-mini-fab
                        color="primary"
                        type="button"
                        data-cy="asset-robot-add">
                    <mat-icon>add</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>
    <ui-grid-column [title]="'assets_modal_grid_robot' | translate"
                    [resizeable]="false"
                    property="robotName"
                    width="35%">
    </ui-grid-column>
    <ui-grid-column [title]="'assets_modal_grid_value' | translate"
                    [resizeable]="false"
                    width="65%">
        <ng-template let-entry="data"
                     let-index="index">
            <div *ngIf="isValid(entry)"
                 [matTooltip]="getValueFor(entry)"
                 class="robot-asset-value">
                {{getValueFor(entry)}}
            </div>
            <span *ngIf="!isValid(entry)"
                  translate
                  class="errorMessage">
                assets_modal_grid_value_required_warning
            </span>
        </ng-template>
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [matTooltip]="'assets_modal_grid_action_edit' | translate"
                    [uiClickTrack]="'Action: Grid: Edit'"
                    (click)="expandRow(entry)"
                    mat-icon-button
                    type="button"
                    data-cy="asset-robot-edit">
                <mat-icon svgIcon="uipath:Edit"></mat-icon>
            </button>
            <button [matTooltip]="'assets_modal_grid_action_remove' | translate"
                    [uiClickTrack]="'Action: Grid: Remove'"
                    (click)="removeRow(entry)"
                    color="warn"
                    mat-icon-button
                    type="button"
                    data-cy="asset-robot-remove">
                <mat-icon svgIcon="uipath:Delete"></mat-icon>
            </button>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-expanded-row>
        <ng-template let-entry="data">
            <div class="robot-asset-form-container">
                <form [formGroup]="formGroup">
                    <mat-form-field>
                        <ui-suggest [value]="selectedRobot"
                                    [searchSourceFactory]="robotSearchFactory"
                                    [placeholder]="'robot_value_editor_form_robot' | translate"
                                    [defaultValue]="'robot_value_editor_form_robot_empty' | translate"
                                    [clearable]="false"
                                    [required]="true"
                                    [displayCount]="5"
                                    (selected)="onRobotChange($event)"
                                    direction="up"
                                    formControlName="robot"
                                    data-cy="asset-robot">
                        </ui-suggest>
                        <mat-hint *ngIf="formGroup.get('robot')?.touched &&
                                        formGroup.get('robot')?.hasError('invalidRobot')"
                                  translate
                                  class="errorMessage">
                            robot_value_editor_form_robot_required_warning
                        </mat-hint>
                        <mat-hint *ngIf="formGroup.get('robot')?.touched &&
                                        formGroup.get('robot')?.hasError('duplicateRobot')"
                                  translate
                                  class="errorMessage">
                            robot_value_editor_form_robot_duplicate_warning
                        </mat-hint>
                    </mat-form-field>
                    <ui-value-type #assetValue
                                   [readonlyCredential]="readonly"
                                   [type]="type"
                                   [scope]="AssetScope.PerRobot"
                                   [isRobot]="true"
                                   [valuePlaceholder]="typeLabel"
                                   [externalNamePlaceholder]="'assets_modal_form_external_name' | translate"
                                   [usernamePlaceholder]="'assets_modal_form_username' | translate"
                                   [passwordPlaceholder]="'assets_modal_form_password' | translate"
                                   [truePlaceholder]="'assets_modal_form_bool_true' | translate"
                                   [falsePlaceholder]="'assets_modal_form_bool_false' | translate"
                                   [tooltipShow]="'password_toggle_show' | translate"
                                   [tooltipHide]="'password_toggle_hide' | translate"
                                   [form]="formGroup"
                                   (keyup.enter)="onSave()"
                                   formControlName="robotValue"
                                   data-cy="asset-value-robot">
                        <ui-value-primary-hints [form]="formGroup"
                                                name="robotValue"
                                                hint-primary>
                        </ui-value-primary-hints>
                        <ng-container hint-secondary>
                            <ui-value-secondary-hints [form]="formGroup"
                                                      name="robotValue"
                                                      hint-secondary>
                            </ui-value-secondary-hints>
                            <ng-container *ngIf="formGroup.getError('robotChanged')">
                                {{ 'asset_robot_changed_warning' | translate }}
                            </ng-container>
                        </ng-container>
                    </ui-value-type>
                </form>
                <div class="robot-asset-form-actions">
                    <button (click)="onCancel()"
                            mat-button
                            type="button"
                            color="warn"
                            data-cy="asset-robot-cancel">
                        {{ 'modal_action_cancel' | translate }}
                    </button>
                    <button [disabled]="formGroup.invalid"
                            (click)="onSave()"
                            mat-button
                            type="button"
                            color="primary"
                            data-cy="asset-robot-persist">
                        <ng-container *ngIf="editedRobot!.id === -1; else saveLabel">
                            {{ 'assets_modal_action_add' | translate }}
                        </ng-container>
                        <ng-template #saveLabel>
                            {{ 'robot_value_editor_save' | translate }}
                        </ng-template>
                    </button>
                </div>
            </div>
        </ng-template>
    </ui-grid-expanded-row>
</ui-grid>
